export const createShadows = () => [
    'none',
    '0px 1px 2px rgba(17, 25, 39, 0.06), 0px 1px 1px rgba(17, 25, 39, 0.03)',
    '0px 2px 4px rgba(17, 25, 39, 0.06), 0px 1px 2px rgba(17, 25, 39, 0.04)',
    '0px 3px 8px rgba(17, 25, 39, 0.07), 0px 1px 3px rgba(17, 25, 39, 0.04)',
    '0px 4px 10px rgba(17, 25, 39, 0.07), 0px 2px 4px rgba(17, 25, 39, 0.04)',
    '0px 6px 14px rgba(17, 25, 39, 0.08), 0px 2px 6px rgba(17, 25, 39, 0.04)',
    '0px 8px 18px rgba(17, 25, 39, 0.08), 0px 3px 8px rgba(17, 25, 39, 0.04)',
    '0px 10px 22px rgba(17, 25, 39, 0.08), 0px 4px 10px rgba(17, 25, 39, 0.05)',
    '0px 12px 24px rgba(17, 25, 39, 0.09), 0px 4px 12px rgba(17, 25, 39, 0.05)',
    '0px 12px 28px rgba(17, 25, 39, 0.09), 0px 5px 14px rgba(17, 25, 39, 0.05)',
    '0px 14px 30px rgba(17, 25, 39, 0.09), 0px 6px 16px rgba(17, 25, 39, 0.05)',
    '0px 16px 32px rgba(17, 25, 39, 0.1), 0px 6px 16px rgba(17, 25, 39, 0.06)',
    '0px 18px 34px rgba(17, 25, 39, 0.1), 0px 7px 18px rgba(17, 25, 39, 0.06)',
    '0px 20px 36px rgba(17, 25, 39, 0.1), 0px 8px 20px rgba(17, 25, 39, 0.06)',
    '0px 22px 38px rgba(17, 25, 39, 0.11), 0px 9px 22px rgba(17, 25, 39, 0.06)',
    '0px 24px 40px rgba(17, 25, 39, 0.11), 0px 10px 24px rgba(17, 25, 39, 0.06)',
    '0px 26px 42px rgba(17, 25, 39, 0.11), 0px 11px 26px rgba(17, 25, 39, 0.07)',
    '0px 28px 44px rgba(17, 25, 39, 0.12), 0px 12px 28px rgba(17, 25, 39, 0.07)',
    '0px 30px 46px rgba(17, 25, 39, 0.12), 0px 13px 30px rgba(17, 25, 39, 0.07)',
    '0px 32px 48px rgba(17, 25, 39, 0.12), 0px 14px 32px rgba(17, 25, 39, 0.07)',
    '0px 34px 50px rgba(17, 25, 39, 0.13), 0px 15px 34px rgba(17, 25, 39, 0.07)',
    '0px 36px 52px rgba(17, 25, 39, 0.13), 0px 16px 36px rgba(17, 25, 39, 0.08)',
    '0px 38px 54px rgba(17, 25, 39, 0.13), 0px 17px 38px rgba(17, 25, 39, 0.08)',
    '0px 40px 56px rgba(17, 25, 39, 0.14), 0px 18px 40px rgba(17, 25, 39, 0.08)',
    '0px 42px 58px rgba(17, 25, 39, 0.14), 0px 19px 42px rgba(17, 25, 39, 0.08)'
]
